"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHideFormOnCustomerIdChange = exports.PhoneManager = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _Feedback = require("./components/Feedback");
var _FormattedMessage = require("./components/FormattedMessage");
var _Telephone = require("./components/Telephone");
var _constants = require("./constants");
var _defaultTranslations = require("./constants/defaultTranslations");
var _phoneContext = require("./contexts/phoneContext");
var _TranslationKey = require("./models/TranslationKey");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const collapseIconClass = () => ({
  fontSize: '25px'
});
const ArrowUpThinIcon = (0, _mui.styled)(_icons.ArrowUpThin)(collapseIconClass);
const ArrowDownThinIcon = (0, _mui.styled)(_icons.ArrowDownThin)(collapseIconClass);
const CollapseBox = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});
const useHideFormOnCustomerIdChange = (hideForm, customerId, condition = true) => {
  (0, _react.useEffect)(() => {
    if (condition) {
      hideForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we not needed update on other property
  }, [customerId]);
};
exports.useHideFormOnCustomerIdChange = useHideFormOnCustomerIdChange;
const PhoneManager = ({
  sectionType
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    phones,
    phoneMetadata: telephoneMetadata,
    dataCompletenessMetadata,
    refreshPhones,
    isLoading,
    currentCustomerId
  } = (0, _phoneContext.usePhoneContext)();
  const telephone = phones.map(item => ({
    isChecked: item.isPrimary || false,
    label: item.telephoneNumber ?? '',
    value: item.telephoneId ?? '',
    connectWithWhatsApp: item.connections?.whatsApp,
    ...item
  }));
  const [additional, setAdditional] = (0, _react.useState)(false);
  const [selectedItem, setSelectedItem] = (0, _react.useState)(undefined);
  const [displayMode, setDisplayMode] = (0, _react.useState)(_constants.DisplayMode.Hidden);
  const [displayFeedback, setDisplayFeedback] = (0, _react.useState)(_constants.DisplayFeedback.Hidden);
  const [shouldResendCode, setShouldResendCode] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!isLoading && phones.length === 0) {
      setDisplayMode(_constants.DisplayMode.Create);
    }
  }, [isLoading, phones.length]);
  const additionalPhones = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
    id: _TranslationKey.TranslationKey.additionalPhones,
    defaultMessage: _defaultTranslations.defaultTranslations.additionalPhones
  });
  const primaryTelephoneNumber = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
    id: _TranslationKey.TranslationKey.primaryTelephoneNumber,
    defaultMessage: _defaultTranslations.defaultTranslations.primaryTelephoneNumber
  });
  const {
    operations,
    isPrimary,
    isVerificationEnabled,
    connections
  } = telephoneMetadata;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
  const canEdit = operations?.update?.isEnabled || operations?.delete?.isEnabled || false;
  const canDeletePrimary = operations?.deletePrimary?.isEnabled ?? false;
  const switchPrimary = isPrimary?.isEditable;
  const isCheckoutSection = sectionType === 'checkout';
  const verification = isVerificationEnabled ?? false;
  const connectWithWhatsApp = connections?.whatsApp;
  const isWhatsUp = connectWithWhatsApp?.isAvailable ?? false;
  const handleOpenEdit = (0, _react.useCallback)(option => {
    setSelectedItem(option);
    setDisplayMode(_constants.DisplayMode.Update);
  }, []);
  const hideEdit = feedback => {
    if (feedback != null) {
      setDisplayFeedback(feedback);
    }
    refreshPhones();
    setShouldResendCode(false);
    setDisplayMode(_constants.DisplayMode.Hidden);
  };
  useHideFormOnCustomerIdChange(hideEdit, currentCustomerId ?? customerId, displayMode === _constants.DisplayMode.Create || displayMode === _constants.DisplayMode.Update || displayMode === _constants.DisplayMode.Verify);
  const handleOpenVerification = (0, _react.useCallback)(option => {
    setSelectedItem(option);
    setShouldResendCode(true);
    setDisplayMode(_constants.DisplayMode.Verify);
  }, []);
  const toggleAdditionalPhones = () => setAdditional(prev => !prev);
  const renderPrimaryTelephone = isPrimaryOption => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!isCheckoutSection && telephone.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "body1",
      fontWeight: "bold",
      align: "left",
      sx: {
        mb: 1
      },
      children: primaryTelephoneNumber
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneBox, {
      canSwitchPrimary: false,
      canDeletePrimary: canDeletePrimary,
      canUpdate: canEdit,
      option: isPrimaryOption,
      verification: verification,
      whatsUpEnabled: isWhatsUp,
      dataTestId: "primary-telephone",
      onEdit: handleOpenEdit,
      isCheckoutSection: isCheckoutSection,
      onVerify: handleOpenVerification
    })]
  });
  const displayAdditionalPhones = options => {
    const optionsWithoutPrimary = options.filter(option => !option.isChecked);
    const verification = isVerificationEnabled ?? false;
    let results;
    if (optionsWithoutPrimary.length <= 2) {
      results = optionsWithoutPrimary.map((option, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneBox, {
        option: option,
        verification: verification,
        canUpdate: canEdit,
        whatsUpEnabled: isWhatsUp,
        canSwitchPrimary: switchPrimary,
        dataTestId: `additional-telephone-${index}`,
        onEdit: handleOpenEdit,
        onVerify: handleOpenVerification,
        isCheckoutSection: isCheckoutSection
      }, option.value));
    } else {
      results = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneBox, {
          option: optionsWithoutPrimary[0],
          verification: verification,
          canUpdate: canEdit,
          whatsUpEnabled: isWhatsUp,
          canSwitchPrimary: switchPrimary,
          dataTestId: "additional-telephone-0",
          onEdit: handleOpenEdit,
          onVerify: handleOpenVerification,
          isCheckoutSection: isCheckoutSection
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneBox, {
          option: optionsWithoutPrimary[1],
          verification: verification,
          canUpdate: canEdit,
          canSwitchPrimary: switchPrimary,
          whatsUpEnabled: isWhatsUp,
          dataTestId: "additional-telephone-1",
          onEdit: handleOpenEdit,
          onVerify: handleOpenVerification,
          isCheckoutSection: isCheckoutSection
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          align: "center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
            color: "default",
            variant: "text",
            "data-testid": getTestId('show-more-telephones-button'),
            onClick: toggleAdditionalPhones,
            children: additional ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(CollapseBox, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: _TranslationKey.TranslationKey.showLess,
                defaultMessage: _defaultTranslations.defaultTranslations.showLess
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ArrowUpThinIcon, {})]
            }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(CollapseBox, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: _TranslationKey.TranslationKey.showMore,
                defaultMessage: _defaultTranslations.defaultTranslations.showMore
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ArrowDownThinIcon, {})]
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Collapse, {
          in: additional,
          children: optionsWithoutPrimary.slice(2).map((option, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneBox, {
            option: option,
            verification: verification,
            canUpdate: canEdit,
            canSwitchPrimary: switchPrimary,
            whatsUpEnabled: isWhatsUp,
            dataTestId: `additional-telephone-collapsed-${index}`,
            onEdit: handleOpenEdit,
            onVerify: handleOpenVerification,
            isCheckoutSection: isCheckoutSection
          }, option.value))
        })]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      mt: 6,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        fontWeight: "bold",
        align: "left",
        sx: {
          mb: 1
        },
        children: additionalPhones
      }), results]
    });
  };
  const addButtonHandler = (0, _react.useCallback)(() => {
    setSelectedItem(undefined);
    setDisplayMode(_constants.DisplayMode.Create);
  }, []);
  const renderAddButton = operations => {
    const canAdd = (operations?.create?.isEnabled ?? false) && !isCheckoutSection;
    if (canAdd) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
        mt: 6,
        display: "flex",
        alignItems: "center",
        component: "label",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
          variant: "text",
          size: "small",
          color: "primary",
          "data-testid": getTestId('add-telephone-button'),
          onClick: addButtonHandler,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          fontWeight: "bold",
          variant: "body1",
          sx: {
            marginLeft: 2
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: _TranslationKey.TranslationKey.newNumber,
            defaultMessage: _defaultTranslations.defaultTranslations.newNumber
          })
        })]
      });
    }
    return null;
  };
  const telephoneProps = {
    telephone,
    telephoneMetadata,
    customerId: currentCustomerId ?? customerId,
    dataCompletenessMetadata,
    isCheckoutSection,
    shouldResendCode,
    setShouldResendCode
  };
  const renderForm = () => {
    if (sectionType === 'checkout') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneForm, {
        ...telephoneProps,
        setDisplayMode: mode => setDisplayMode(mode),
        hideFormHandler: hideEdit,
        selectedItem: selectedItem,
        displayMode: displayMode
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneTitle, {
        phoneDisplayMode: displayMode,
        sectionType: sectionType
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneForm, {
        ...telephoneProps,
        setDisplayMode: mode => setDisplayMode(mode),
        hideFormHandler: hideEdit,
        selectedItem: selectedItem,
        displayMode: displayMode
      })]
    });
  };
  const isPrimaryOption = telephone?.find(options => options.isChecked);
  if (displayMode === _constants.DisplayMode.Create || displayMode === _constants.DisplayMode.Update || displayMode === _constants.DisplayMode.Verify) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: renderForm()
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    "data-testid": getTestId('telephones'),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Telephone.TelephoneTitle, {
      phoneDisplayMode: displayMode,
      sectionType: sectionType
    }), isPrimaryOption ? renderPrimaryTelephone(isPrimaryOption) : null, telephone?.length > 1 && !isCheckoutSection ? displayAdditionalPhones(telephone) : null, renderAddButton(operations), isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {
        color: "default"
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Feedback.Feedback, {
      displayFeedback: displayFeedback,
      closeFeedback: () => setDisplayFeedback(_constants.DisplayFeedback.Hidden)
    })]
  });
};
exports.PhoneManager = PhoneManager;
